import { Component } from '@angular/core';

@Component({
  selector: 'zc-sidebar-body',
  templateUrl: './sidebar-body.component.html',
  styleUrls: ['./sidebar-body.component.scss'],
})
export class SidebarBodyComponent {}
